import arAssets from "../locales/ar/assets.json";
import arCash from "../locales/ar/cash.json";
import arCommon from "../locales/ar/common.json";
import arCrm from "../locales/ar/crm.json";
import arDash from "../locales/ar/dash.json";
import arOps from "../locales/ar/ops.json";
import arDevice from "../locales/ar/device.json";
import arErrors from "../locales/ar/errors.json";
import arGl from "../locales/ar/gl.json";
import arHr from "../locales/ar/hr.json";
import arInv from "../locales/ar/inv.json";
import arLoyalty from "../locales/ar/loyalty.json";
import arMdCatalog from "../locales/ar/mdCatalog.json";
import arMdFinance from "../locales/ar/mdFinance.json";
import arMsg from "../locales/ar/msg.json";
import arPlatform from "../locales/ar/platform.json";
import arPos from "../locales/ar/pos.json";
import arPurch from "../locales/ar/purch.json";
import arProc from "../locales/ar/proc.json";
import arScm from "../locales/ar/scm.json";
import arQuality from "../locales/ar/quality.json";
import arLease from "../locales/ar/lease.json";
import arJewel from "../locales/ar/jewel.json";
import arFleet from "../locales/ar/fleet.json";
import arParking from "../locales/ar/parking.json";
import arRpt from "../locales/ar/rpt.json";
import arSales from "../locales/ar/sales.json";
import arShell from "../locales/ar/shell.json";
import arTax from "../locales/ar/tax.json";
import arUi from "../locales/ar/ui.json";
import arWork from "../locales/ar/work.json";
import enAssets from "../locales/en/assets.json";
import enCash from "../locales/en/cash.json";
import enCommon from "../locales/en/common.json";
import enCrm from "../locales/en/crm.json";
import enDash from "../locales/en/dash.json";
import enOps from "../locales/en/ops.json";
import enDevice from "../locales/en/device.json";
import enErrors from "../locales/en/errors.json";
import enGl from "../locales/en/gl.json";
import enHr from "../locales/en/hr.json";
import enInv from "../locales/en/inv.json";
import enLoyalty from "../locales/en/loyalty.json";
import enMdCatalog from "../locales/en/mdCatalog.json";
import enMdFinance from "../locales/en/mdFinance.json";
import enMsg from "../locales/en/msg.json";
import enPlatform from "../locales/en/platform.json";
import enPos from "../locales/en/pos.json";
import enPurch from "../locales/en/purch.json";
import enProc from "../locales/en/proc.json";
import enScm from "../locales/en/scm.json";
import enQuality from "../locales/en/quality.json";
import enLease from "../locales/en/lease.json";
import enJewel from "../locales/en/jewel.json";
import enFleet from "../locales/en/fleet.json";
import enParking from "../locales/en/parking.json";
import enRpt from "../locales/en/rpt.json";
import enSales from "../locales/en/sales.json";
import enShell from "../locales/en/shell.json";
import enTax from "../locales/en/tax.json";
import enUi from "../locales/en/ui.json";
import enWork from "../locales/en/work.json";

/** Namespaces: one per module plus shared ones (ADR-0009/D-1). */
export const namespaces = [
  "common",
  "errors",
  "shell",
  "ui",
  "platform",
  "mdFinance",
  "mdCatalog",
  "gl",
  "inv",
  "cash",
  "purch",
  "sales",
  "tax",
  "hr",
  "assets",
  "device",
  "pos",
  "msg",
  "rpt",
  "loyalty",
  "work",
  "crm",
  "quality",
  "proc",
  "scm",
  "lease",
  "jewel",
  "parking",
  "fleet",
  "ops",
  "dash",
] as const;
export type Namespace = (typeof namespaces)[number];

export const defaultNamespace: Namespace = "common";

/** English resources are the typing source for keys. */
export const enResources = {
  common: enCommon,
  errors: enErrors,
  shell: enShell,
  ui: enUi,
  platform: enPlatform,
  mdFinance: enMdFinance,
  mdCatalog: enMdCatalog,
  gl: enGl,
  inv: enInv,
  cash: enCash,
  purch: enPurch,
  sales: enSales,
  tax: enTax,
  hr: enHr,
  assets: enAssets,
  device: enDevice,
  pos: enPos,
  msg: enMsg,
  rpt: enRpt,
  loyalty: enLoyalty,
  work: enWork,
  crm: enCrm,
  quality: enQuality,
  proc: enProc,
  scm: enScm,
  lease: enLease,
  jewel: enJewel,
  parking: enParking,
  fleet: enFleet,
  ops: enOps,
  dash: enDash,
} as const;

export const resources = {
  en: enResources,
  ar: {
    common: arCommon,
    errors: arErrors,
    shell: arShell,
    ui: arUi,
    platform: arPlatform,
    mdFinance: arMdFinance,
    mdCatalog: arMdCatalog,
    gl: arGl,
    inv: arInv,
    cash: arCash,
    purch: arPurch,
    sales: arSales,
    tax: arTax,
    hr: arHr,
    assets: arAssets,
    device: arDevice,
    pos: arPos,
    msg: arMsg,
    rpt: arRpt,
    loyalty: arLoyalty,
    work: arWork,
    crm: arCrm,
    quality: arQuality,
    proc: arProc,
    scm: arScm,
    lease: arLease,
    jewel: arJewel,
    parking: arParking,
    fleet: arFleet,
    ops: arOps,
    dash: arDash,
  },
} as const;
